import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import api from '../../core/api';
import BusinessForm from '../../components/forms/BusinessForm';
import {CircularProgress} from '@material-ui/core';

const EditBusiness = ({history, match}) => {
  const [loading, setLoading] = useState(false);
  const [business, setBusiness] = useState({});

  const fetchBusiness = async () => {
    setLoading(true);
    try {
      const {data: business} = await api.get(
        `/business/${match.params.businessId}`,
      );
      setBusiness({
        ...business,
        contacts: business.collaborators,
        plans:
          business.business_commercials.length > 0
            ? business.business_commercials
            : [
                {title: 'Plano Mensal 1', planType: 'M'},
                {title: 'Plano Mensal 2', planType: 'M'},
                {title: 'Plano Mensal 3', planType: 'M'},
                {title: 'Plano Anual 1', planType: 'Y'},
                {title: 'Plano Anual 2', planType: 'Y'},
                {title: 'Plano Anual 3', planType: 'Y'},
                {title: 'Plano Special 1', planType: 'S'},
                {title: 'Plano Special 2', planType: 'S'},
                {title: 'Plano Special 3', planType: 'S'},
              ],
        currentPlans: business.business_commercials,
        headquarterCNPJ: business.headquarter_cnpj,
        groupCompanies: business.group_companies
          ? JSON.parse(business.group_companies)
          : [],

        address: {
          street: business.street,
          number: business.number,
          complement: business.complement,
          neighborhood: business.neighborhood,
          city: business.city,
          state: business.state,
          country: business.country,
          postalCode: business.postalCode,
        },
      });
      console.log('business to edit', business)
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBusiness();
  }, []);

  return (
    <Dashboard>
      {!loading && business.id ? (
        <BusinessForm history={history} business={business} />
      ) : (
        <div className="flex-col center-a center-b" style={{height: '50vh'}}>
          <CircularProgress size={100} />
          <p> Carregando... </p>
        </div>
      )}
    </Dashboard>
  );
};

export default EditBusiness;
